import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import sampleImage from "../assets/Blackwomen/BWI11.jpg"; // Consider replacing with an image showing a complex app, code, or a visionary leader

const AccordionItem = ({ title, children, isOpen, onClick }) => (
  <div className="border-b border-gray-200">
    <button
      onClick={onClick}
      className="w-full text-left py-4 px-6 flex items-center justify-between bg-[#F3FAF9] hover:bg-[#e6f1f0] transition-colors"
    >
      <span className="uppercase text-sm tracking-wide text-gray-700">{title}</span>
      {isOpen ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
    </button>
    {isOpen && <div className="px-6 pb-4 text-gray-700 text-sm">{children}</div>}
  </div>
);

export default function CEOGlowUp() {
  const [openIndex, setOpenIndex] = useState(0); // Default open: What's Included

  const toggleIndex = (index) => setOpenIndex((prev) => (prev === index ? null : index));

  return (
    <div className="max-w-6xl mx-auto mt-12 px-4 grid grid-cols-1 md:grid-cols-2 gap-10 items-start mb-20">

      {/* Left Side - Image */}
      <div className="w-full py-24">
        <img
          src={sampleImage}
          alt="Enterprise custom web application"
          className="shadow-xl w-full h-[500px] object-cover"
        />
      </div>

      {/* Right Side - Content & Accordion */}
      <div>
        <p className="uppercase text-sm text-[#c6884a] tracking-widest mb-2">Enterprise Custom Web Application & Strategy</p>
        <h1 className="text-4xl  text-gray-900 mb-4">The CEO Glow-Up (VIP)</h1>
        <p className="text-gray-700 mb-8">
          For 6-figure+ women entrepreneurs ready for a premium, high-converting, and bespoke web application that cements their position as an industry leader.
        </p>

        <div className="border border-gray-200 rounded overflow-hidden shadow-sm">
          <AccordionItem
            title="What's Included"
            isOpen={openIndex === 0}
            onClick={() => toggleIndex(0)}
          >
            <ul className="list-disc list-inside space-y-1">
              <li>Comprehensive App Strategy & Business Process Automation Intensive</li>
              <li>Bespoke Enterprise-Grade Web Application (10+ custom modules/pages) built with React, Tailwind, Firebase</li>
              <li>Advanced Database Architecture for complex data and high user loads</li>
              <li>Seamless Third-Party API Integrations (e.g., advanced CRM, marketing automation, payment gateways)</li>
              <li>Custom Analytics & Reporting Dashboard</li>
              <li>Real-time features (e.g., notifications, live chat, interactive content)</li>
              <li>Content Marketing & Authority Building Strategy integrated into the app</li>
              <li>Robust Security Features & Compliance planning</li>
              <li>Custom admin panel for full app control</li>
              <li>60 days dedicated post-launch support & optimization</li>
            </ul>
          </AccordionItem>

          <AccordionItem
            title="Requirements/Not Included"
            isOpen={openIndex === 1}
            onClick={() => toggleIndex(1)}
          >
            <ul className="list-disc list-inside space-y-1">
              <li>Development of custom mobile native apps (iOS/Android)</li>
              <li>Extensive ongoing platform maintenance after the 60-day support window (available separately)</li>
              <li>Subscription costs for any integrated third-party services</li>
            </ul>
          </AccordionItem>

          <AccordionItem
            title="Timeline"
            isOpen={openIndex === 2}
            onClick={() => toggleIndex(2)}
          >
            <p>Estimated completion: 10–16 weeks depending on scope complexity, feature requirements, and client collaboration.</p>
          </AccordionItem>

          <AccordionItem
            title="Project Investment"
            isOpen={openIndex === 3}
            onClick={() => toggleIndex(3)}
          >
            <p className="mb-3">Starting at $15,000</p>
            <ul className="list-disc list-inside space-y-1">
              <li>30% non-refundable deposit due at signing</li>
              <li>35% due at project kickoff</li>
              <li>35% due 30 days after start date</li>
            </ul>
          </AccordionItem>
        </div>

        {/* CTA */}
        <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:gap-6 gap-3">
          <p className="text-gray-700 text-lg">
            <span className="italic">Investment begins at:</span>{' '}
            <span className="text-2xl text-gray-900  font-medium">$7,000</span>
          </p>
          <a href="/contact">
          <button className="bg-[#C18343] text-white uppercase tracking-widest px-6 py-3 text-sm hover:bg-[#a76e33] transition-colors">
            BOOK NOW
          </button>
          </a>
        </div>
      </div>
    </div>
  );
}